import { store } from "../store";
const jsonwebtoken = require("jsonwebtoken");

let token = store.getters["getToken"];
let refreshToken = store.getters["getRefreshToken"];

export const tokenValidated = async function (to, from, next) {
  const decodedToken = jsonwebtoken.decode(token);
  if (Math.floor(Date.now() / 1000) > decodedToken.exp) {
    // const d = new Date(0);
    // d.setUTCSeconds(decodedToken.exp);
    // console.log({
    //   token: "is expired",
    //   expired: d,
    //   refreshToken: refreshToken,
    // });
    //
    // console.log(`get new tokens token using refresh token: ${refreshToken}`);

    const response = await fetch("http://vdata.co.za/api/auth/token", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        refreshToken: refreshToken,
      }),
    });

    const {
      data: { token, refresh },
    } = await response.json();

    await store.dispatch("setToken", token);
    await store.dispatch("setRefreshToken", refresh);
  }

  next();
};
